




































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
// components
import Keyboard from "@/components/posts/wayfinder/keyboards/Keyboard.vue";
import { RenderPostModel } from "@/services/render/types";
import { getWayfinderRender } from "@/services/render/renderService";
import { Style } from "@/services/styles/types";
import { WayfinderCSS, WayfinderProperties, WayfinderRenderModel } from "@/services/wayfinder/types";
import { setNextItem } from "../types";

@Component({
    components: {
        Keyboard
    }
})
export default class WayfinderRender extends Vue {
    @Prop() private item!: RenderPostModel;
    @Prop() private active!: number;
    @Prop() private token!: string;
    @Prop() private itemStyle!: Style; // it's used only in style form preview

    filter: string = "";
    wayfinders = [] as WayfinderRenderModel[];
    selectedPerson: any = null;

    setNextItemTimer = 0;
    @Watch("active", { immediate: true, deep: true })
    onActiveChange(value: number) {
        if (value !== 0) {
            clearTimeout(this.setNextItemTimer);
            this.setNextItemTimer = setTimeout(this.setNextItem,
                (this.properties as any).showTime * 1000);
        }
    }

    // Lyfecycle
    created() {
        this.fetchData();
    }

    // computed
    get properties() {
        return this.item.properties as WayfinderProperties;
    }

    get styleModel() {
        return this.item.css && Object.entries(this.item.css).length > 0 && this.item.css.constructor === Object ? this.item.css as WayfinderCSS : this.itemStyle ? this.itemStyle.css as WayfinderCSS : {} as WayfinderCSS;
    }

    get filteredWayfinders() {
        let result = this.wayfinders;

        if (this.filter) {
            result = result.filter(x => x.fullName.toLowerCase().includes(this.filter.toLowerCase()));
        }

        return result.sort((a, b) => a.fullName.localeCompare(b.fullName, "da", { numeric: true }));
    }

    get selectedPersonNameStyle() {
        return `width: ${this.selectedPerson.wayfinder.location.locationSimple.displayPersonNameWidth}px;
            height: ${this.selectedPerson.wayfinder.location.locationSimple.displayPersonNameHeight}px;
            left: ${this.selectedPerson.wayfinder.location.locationSimple.displayPersonNameX}px;
            top: ${this.selectedPerson.wayfinder.location.locationSimple.displayPersonNameY}px;
            position: absolute;
            ${this.styleModel.NameLocationPanel}`;
    }

    get selectedPersonDescriptionStyle() {
        return `width: ${this.selectedPerson.wayfinder.location.locationSimple.displayPersonDescWidth}px;
            height: ${this.selectedPerson.wayfinder.location.locationSimple.displayPersonDescHeight}px;
            left: ${this.selectedPerson.wayfinder.location.locationSimple.displayPersonDescX}px;
            top: ${this.selectedPerson.wayfinder.location.locationSimple.displayPersonDescY}px;
            position: absolute;
            ${this.styleModel.DescriptionLocationPanel}`;
    }

    async fetchData() {
        this.wayfinders = await getWayfinderRender(this.properties.wayfinderId);
    }

    setNextItem() {
        this.$emit("setNextItem", { id: this.item.id } as setNextItem);
    }

    onWrite(text: string) {
        this.filter = text;
    }

    viewWayfinder(item: any) {
        this.selectedPerson = item;
    }

    get backgroundStyle() {
        return {
            top: "",
            left: "",
            right: "",
            bottom: "",
            position: "",
            margin: "",
            width: `${this.selectedPerson.wayfinder.location.map.mapWidth}px`,
            height: `${this.selectedPerson.wayfinder.location.map.mapHeight}px`
        };
    }

    get locationMarkerStyle() {
        return {
            top: `${this.selectedPerson.wayfinder.location.y}px`,
            left: `${this.selectedPerson.wayfinder.location.x}px`,
            right: "",
            bottom: "",
            position: "absolute",
            margin: ""
        };
    }

    back() {
        this.selectedPerson = null;
    }
}
